export const FETCH_ALL = 'locations_List';

export const FETCH = 'locations_FindById';

export const CREATE = 'locations_CreateOne';

export const EDIT = 'locations_UpdateById';

export const DELETE = 'locations_RemoveManyByIds';
